var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.544 1.23365V14.7664C11.544 15.5285 10.8586 16.1082 10.1056 15.9829L3.0379 14.8069C2.24372 14.6747 1.66162 13.9887 1.66162 13.1848V2.81526C1.66162 2.01138 2.24372 1.32533 3.0379 1.19318L10.1056 0.0170855C10.8586 -0.108206 11.544 0.471523 11.544 1.23365ZM13.191 2.24447C14.0594 2.24447 14.7707 2.91531 14.8336 3.7662L14.8381 3.88892V12.1112C14.8381 12.9782 14.1662 13.6884 13.314 13.7511L13.191 13.7557H12.3675V2.24447H13.191ZM7.83809 6.76672C7.15588 6.76672 6.6028 7.31893 6.6028 8.00006C6.6028 8.6812 7.15588 9.23341 7.83809 9.23341C8.5203 9.23341 9.07339 8.6812 9.07339 8.00006C9.07339 7.31893 8.5203 6.76672 7.83809 6.76672Z",
    fill: "#61C1A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIc);
export default __webpack_public_path__ + "static/media/open_ic.85a216aec4eb9007e5ce1cf2430bdd51.svg";
export { ForwardRef as ReactComponent };